import AccessLevelForm from "./AccessLevelForm";
import AccessLevelTable from "./AccessLevelTable";

function AccessLevel() {
  return (
    <>
      <AccessLevelForm />
      <AccessLevelTable />
    </>
  );
}

export default AccessLevel;
